import { BlockComponentProps } from 'client-react-block-renderer';
import React, { Component } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './RotatingBannerImageBlockComponent.scss';
interface Config {
    slides: [
        {
            imageSrc: string,
            xsImageSrc: string,
            href: string
        }
    ];
    interval: string;
    stopOnHover: boolean;
}

interface Data { }

type Props = BlockComponentProps<Data, Config>;

interface State { }

export default class RotatingBannerImageBlockComponent extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.handleCarouselItemClick = this.handleCarouselItemClick.bind(this);
    }
    protected handleCarouselItemClick(index) {
        window.location.href = this.props.config.slides[index].href;
    }
    public render() {
        return (
            <div className="RotatingBannerImageBlockComponent">
                <Carousel
                    infiniteLoop={true}
                    autoPlay={true}
                    showThumbs={false}
                    showStatus={false}
                    onClickItem={this.handleCarouselItemClick}
                    interval={parseInt(this.props.config.interval)}
                    stopOnHover={this.props.config.stopOnHover}
                >
                    {this.props.config.slides.map((slide, index) => (
                        <div key={index}>
                            <img src={slide.imageSrc} className="hidden-xs" />
                            <img src={slide.xsImageSrc} className="visible-xs" />
                        </div>

                    ))}
                </Carousel>
            </div>
        );
    }
}
